import { useRef, useCallback, useEffect } from "react";
import { AppShellProvider, useAppShell } from "./AppShellContext";
import TopBar from "./components/TopBar";
import BottomTabBar from "./components/BottomTabBar";
import InstallPrompt from "./components/InstallPrompt";
import HomeScreen from "./screens/HomeScreen";
import ExploreScreen from "./screens/ExploreScreen";
import SakshamScreen from "./screens/SakshamScreen";
import ConnectScreen from "./screens/ConnectScreen";
import YouScreen from "./screens/YouScreen";
import MobileJournal from "./screens/MobileJournal";
import MentorsPage from "../components/MentorsPage"; // 👈 Updated Import
import "./styles/mobile.css";

// ── Screen registry ──
const SCREENS = [
  { id: "home",    component: HomeScreen },
  { id: "explore", component: ExploreScreen },
  { id: "saksham", component: SakshamScreen },
  { id: "connect", component: ConnectScreen },
  { id: "you",     component: YouScreen },
  { id: "mentor",  component: MentorsPage }, // 👈 Updated Component
  { id: "journal", component: MobileJournal }, 
];

// ── Inner shell (needs context) ──
function ShellInner() {
  const { activeTab, isDark } = useAppShell();

  // Scroll position preservation
  const scrollRefs = useRef({
    home: null,
    explore: null,
    saksham: null,
    connect: null,
    you: null,
    mentor: null,
    journal: null, 
  });
  
  const scrollPositions = useRef({
    home: 0,
    explore: 0,
    saksham: 0,
    connect: 0,
    you: 0,
    mentor: 0,
    journal: 0, 
  });
  
  const prevTab = useRef(activeTab);

  // Save scroll position when leaving a tab, restore when entering
  useEffect(() => {
    const prevEl = scrollRefs.current[prevTab.current];
    if (prevEl) {
      scrollPositions.current[prevTab.current] = prevEl.scrollTop;
    }

    const curEl = scrollRefs.current[activeTab];
    if (curEl) {
      curEl.scrollTop = scrollPositions.current[activeTab];
    }

    prevTab.current = activeTab;
  }, [activeTab]);

  const setScrollRef = useCallback((tabId) => (el) => {
    scrollRefs.current[tabId] = el;
  }, []);

  return (
    <div className={`hh-app${isDark ? " dark" : ""}`}>
      <TopBar />

      <div className="hh-screens">
        {SCREENS.map(({ id, component: Screen }) => (
          <div
            key={id}
            ref={setScrollRef(id)}
            className={`hh-screen${activeTab === id ? " active" : ""}`}
            role="tabpanel"
            aria-hidden={activeTab !== id}
          >
            <Screen />
          </div>
        ))}
      </div>

      <BottomTabBar />
      <InstallPrompt />
    </div>
  );
}

// ── Exported wrapper with context provider ──
export default function MobileShell({ user, role }) {
  return (
    <AppShellProvider user={user} role={role}>
      <ShellInner />
    </AppShellProvider>
  );
}